import { render } from "./Version.vue?vue&type=template&id=1ff9240e"
import script from "./Version.vue?vue&type=script&lang=js"
export * from "./Version.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__